import React, { useState } from 'react'
import { BackButton, CancelButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import useFetchMataData from '../../../../Components/Hooks/useFetchMataData';
import { useLocation, useParams } from 'react-router-dom';
import useEditFormData from '../../../../Components/Hooks/useEditFormData';
import { useFormik } from 'formik';
import * as yup from 'yup';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
import { NuDate, NuInput, NuTextArea } from '../../../../Components/Utils/Input';
import FormikSelectTwo from '../../../../Components/Utils/Select';

function EditVehicleMaintence() {
  const { value: mainType } = useFetchMataData(`/dropdown/dropdown-details/`, 'vehicle_mainType')
  const { maintenceId } = useParams();
  // const [loading, setLoading] = useState(false);

  const location = useLocation();
  const data = location.state.data;
  const from = location.state.from;
  console.log(location.state, 'state');
  // const [division, setDivision] = useState([]);
  const { Oncancel, editFormData, contextHolder, isLoading } = useEditFormData();


  const [createNew, setCreateNew] = useState({

    mainDate: data?.mainDate,
    vehicleId: data?.vehicleId,
    mainBy: data?.mainBy,
    mainType: data?.mainType,
    nextMain: data?.nextMain,
    comments: data?.comments,


  })


  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      // email: yup.string().required('Email is required!'),
    }),
    onSubmit: async (value, { resetForm }) => {

      // setLoading(true); 
      editFormData(`/vehicles/edit-maintenance/${maintenceId}`, value, resetForm, from);
      // setLoading(false)
    }
  })
  return (
    <div className="w-full h-full py-2 px-4">
      <div className="w-full flex flex-row justify-between items-center gap-2 mb-3">
        <Breadcrumb
          items={[
            {
              name: "Vehicle",
              link: "/maintenance/vehicle"
            },
            {
              name: "Maintenance Vehicle"
            }
          ]}
        />
        <div className="flex items-center gap-2 flex-shrink-0">
          <BackButton />
        </div>
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="w-full mx-auto min-h-[calc(100vh-145px)] h-auto bg-white rounded-md overflow-hidden mt-4">
          <div className="w-full h-full py-2 flex justify-start content-start flex-wrap px-2 overflow-y-auto">
            <div className="w-full">
              <p className='pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-[#048178] decoration-2 underline-offset-4'>
                Maintenance Details :
              </p>
            </div>

            <NuDate
              label="Maintenance Date"
              placeholder="Maintenance Date"
              formik={formik}
              name="mainDate"
              width="w-full md:w-1/2 lg:w-1/3"
            />
            <NuInput
              type="test"
              label="Maintenance By"
              placeholder="Maintenance By"
              formik={formik}
              name="mainBy"
              width="w-full md:w-1/2 lg:w-1/3"
            />
            <FormikSelectTwo
              label="Maintenance Type"
              placeholder="Choose"
              formik={formik}
              Options={mainType}
              name="mainType"
              width="w-full md:w-1/2 lg:w-1/3"
            />
            <NuDate
              label="Next Maintenance"
              placeholder="Next Maintenance"
              formik={formik}
              name="nextMain"
              width="w-full md:w-1/2 lg:w-1/3"
            />
            <NuTextArea
              label="Comments"
              placeholder="comments"
              formik={formik}
              name="comments"
              width="w-full md:w-1/2 lg:w-1/3"
            />

            <div className="w-full mx-auto my-4 mt-8 px-2">
              <div className="flex justify-end gap-3 sm:gap-4">
                <CancelButton handleClick={() => { Oncancel(-1) }} />
                <SubmitButton isLoading={isLoading} />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}


export default EditVehicleMaintence